import React from "react";
import AdditionalInfo from "../Components/Product/AdditonInfo/AdditionalInfo";
import Product from "../Components/Product/ProductMain/Product";
import RelatedProducts from "../Components/Product/RelatedProducts/RelatedProducts";
import { useSearchParams } from "react-router-dom";

const ProductDetails = () => {
  const [searchParams] = useSearchParams();
  const productId = searchParams.get("id");
  return (
    <>
      <Product productID={productId} />
      <AdditionalInfo productID={productId} />
      <RelatedProducts />
    </>
  );
};

export default ProductDetails;
